
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 32 32"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M15 3h2v2.063c5.268.477 9.46 4.67 9.938 9.938h2.063v2h-2.063A10.989 10.989 0 0117 26.939v2.063h-2v-2.063a10.989 10.989 0 01-9.938-9.938H2.999v-2h2.063A10.989 10.989 0 0115 5.063V3zm0 4.031A8.997 8.997 0 007.031 15H9v2H7.031A8.997 8.997 0 0015 24.969V23h2v1.969A8.997 8.997 0 0024.969 17H23v-2h1.969A8.997 8.997 0 0017 7.031V9h-2V7.031z"}})])
          )
        }
      }
    